const TABLE_CONFIG = {
  handleMoveOutSpeed: 7,
  handleRotationSpeed: 25,
  handleMaxRotations: 8,
  handle360RotationDeltaY: 0.1,
}

export default TABLE_CONFIG;
